import { render, staticRenderFns } from "./v-pop-gift.vue?vue&type=template&id=18254395&scoped=true"
import script from "./v-pop-gift.vue?vue&type=script&lang=js"
export * from "./v-pop-gift.vue?vue&type=script&lang=js"
import style0 from "./v-pop-gift.vue?vue&type=style&index=0&id=18254395&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18254395",
  null
  
)

export default component.exports